import ToggleCaret from '../ToggleCaret';

import Button from './Button';

interface ICollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const CollapseButton = ({ isCollapsed, onToggle }: ICollapseButtonProps) => (
  <Button
    iconLeading={<ToggleCaret isOpen={!isCollapsed} data-icon="leading" />}
    size="sm"
    color="tertiary"
    className="p-1.5"
    aria-label={isCollapsed ? 'Expand' : 'Collapse'}
    onClick={onToggle}
  />
);

export default CollapseButton;
